import VideoSidebar from 'govbr.frontend.policy/components/Blocks/Video/VideoSidebar';

export default VideoSidebar;
